import type { Editor } from "@tiptap/react";

import type { EditorRange, InlineAttachment } from "./types";

interface InsertImageNodeParams {
  attachment: InlineAttachment;
  editor: Editor;
  range: EditorRange;
}

export const insertImageNode = ({
  editor,
  range,
  attachment,
}: InsertImageNodeParams): void => {
  editor
    .chain()
    .focus()
    .insertContentAt(range, [
      {
        type: "image",
        attrs: { ...attachment, width_ratio: 1 },
      },
      { type: "hardBreak" },
    ])
    .run();
};
